<script>
import MixedGrid from '@phoenix/mixins/components/mixedGrid/MixedGrid';
import MixedGridFilters from '@maison/components/mixedGrid/MixedGridFilters.vue';
import Product from '@maison/components/common/Product';
import { map } from 'lodash-es';
import PagePushCard from '@maison/components/molecules/PagePushCard';
import CTA from '@maison/components/common/CTA.vue';
import { PhxGridLayout } from '@sg/src/View/Components/Atoms/GridLayout';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    CTA,
    MixedGridFilters,
    PhxGridLayout,
    PhxsgButton,
    PagePushCard,
    Product,
  },

  mixins: [MixedGrid],

  props: {
    highlightedFilterId: {
      type: String,
      default: '',
    },
    headingTag: {
      type: String,
      default: 'h2',
    },
    mainPagePushItem: {
      type: Object,
      default: null,
    },
    cta: {
      type: Object,
      default: null,
    },
  },

  computed: {
    widths() {
      return {
        '': {},
      };
    },

    loadMoreClasses() {
      return [
        'center center--spacing-4 mt-4',
        map(this.maxPage, (page, size) => {
          const prefix = size !== '' ? `${size}:` : '';
          return this.page >= page ? `${prefix}hidden` : `${prefix}block`;
        }),
      ];
    },
  },

  methods: {
    getDisplayedColumnClasses(column) {
      if (!this.shouldDisplayLoadMore) {
        return [];
      }

      return map(column.page, (page, size) => {
        const prefix = size !== '' ? `${size}:` : '';
        return this.page < page ? `${prefix}hidden` : `${prefix}block`;
      });
    },
  },
};
</script>

<template>
  <div class="center center--spacing-4 center--sizing-3xl mb-4">
    <div class="flex items-center justify-between">
      <component :is="headingTag" class="heading-medium">{{ title }}</component>

      <div class="cluster cluster--spacing-4 justify-end">
        <mixed-grid-filters
          v-if="displayFilter"
          ref="mixedGridFilters"
          :filters="filtersWithLocalizedPrices"
          :empty-filters="emptyFilters"
          :products-count="filteredColumnsCount"
          :unique-id="uniqueId"
          :default-sort="defaultSort"
          :default-filters="activeFilters"
          :should-display-sellable="shouldDisplaySellable"
          :has-filters-in-url="hasFiltersInUrl"
          :highlighted-filter-id="highlightedFilterId"
          :url-param-prefix="urlParamPrefix"
          @on-sort-change="onSortChange"
          @on-filters-changed="onFiltersChanged"
        />

        <c-t-a v-if="cta" v-bind="cta" />
      </div>
    </div>
  </div>

  <phx-grid-layout class="mixed-grid mixed-grid--family" grid-spacing="4">
    <page-push-card
      v-if="mainPagePushItem && hasDefaultSortAndFilters()"
      v-bind="mainPagePushItem"
      class="col-span-2 row-span-2"
    />

    <product
      v-for="column in filteredColumns"
      :key="column.data.itemId"
      v-bind="column.data"
      :display-classes="getDisplayedColumnClasses(column)"
      :data-tracking="column.template === 'product' ? getDataTracking(column.data) : null"
      data-cy="mixed-grid-item"
      :data-cy-item="column.template"
    />
  </phx-grid-layout>

  <section v-if="shouldDisplayLoadMore" :class="loadMoreClasses">
    <div class="form-actions">
      <PhxsgButton variant="fade" data-cy="mixed-grid-see-all" @click="seeAll">
        {{ $t('Button.seeAll') }}
      </PhxsgButton>

      <PhxsgButton variant="fade" data-cy="mixed-grid-load-more" @click="nextPage">
        {{ $t('Button.loadMore') }}
      </PhxsgButton>
    </div>
  </section>
</template>
